import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

interface StyleProps {
  isMobile: boolean;
  createLeaveRequestIsEnabled: string;
}

const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    root: (props) => ({
      display: "flex",
      flexDirection: props.isMobile ? "column-reverse" : "row",
      justifyContent: "space-between",
      paddingTop: 20,
      paddingBottom: 36,
    }),
    leftContainer: (props) => ({
      width: props.createLeaveRequestIsEnabled === "0" ? 0 : 180,
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
    }),
    leftContainerExaminerView: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    rightContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    allApprove: {
      height: "36px",
      letterSpacing: "0.75px",
      // important-flagged styles can be handled via `!important` in a CSS override,
      // but if you need it inline:
      border: "unset !important",
    },
  })
);

export default useStyles;
